
    /**
    * 账户停用
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13340 {}
  /**
 * YResult :YResult
 */
export class IResid13340 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  export default (account: any,  data?: IReqid13340): AxiosPromise<IResid13340> => request({
        method: 'POST',
        url: '/admin/account/stopUsing/'+account,
        data: data
      })